import { useState } from "react";
import { View, Text, Image, TouchableOpacity, KeyboardAvoidingView, Platform, ScrollView } from "react-native";
import { Link } from "expo-router";
import { useAuth } from "../lib/auth";
import { Button } from "../../components/Button";
import { Input } from "../../components/Input";

export default function LoginScreen() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function handleLogin() {
    if (!email || !password) {
      setError("Please fill in all fields");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await signIn(email, password);
    } catch (err: any) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === "ios" ? "padding" : "height"}
      style={{ flex: 1, backgroundColor: "#f9fafb" }}
    >
      <View style={{ paddingHorizontal: 24, paddingTop: Platform.OS === "ios" ? 50 : 16 }}>
        <Link href="/(auth)/" asChild>
          <TouchableOpacity hitSlop={{ top: 12, bottom: 12, left: 12, right: 12 }}>
            <Text style={{ color: "#1B2A4A", fontSize: 14, fontWeight: "600" }}>← Back to Home</Text>
          </TouchableOpacity>
        </Link>
      </View>
      <ScrollView contentContainerStyle={{ flexGrow: 1, justifyContent: "center", padding: 24 }} keyboardShouldPersistTaps="handled">
        <View style={{ marginBottom: 40, alignItems: "center" }}>
          <Image source={require("../../assets/images/logo-full.png")} style={{ height: 100, width: 250 }} resizeMode="contain" />
          <Text style={{ fontSize: 16, color: "#6b7280", marginTop: 8 }}>Track your Fast CAT runs</Text>
        </View>

        {error ? (
          <View style={{ backgroundColor: "#fef2f2", padding: 12, borderRadius: 8, marginBottom: 16 }}>
            <Text style={{ color: "#dc2626", textAlign: "center" }}>{error}</Text>
          </View>
        ) : null}

        <Input
          label="Email"
          value={email}
          onChangeText={setEmail}
          placeholder="you@example.com"
          keyboardType="email-address"
          autoCapitalize="none"
        />
        <Input
          label="Password"
          value={password}
          onChangeText={setPassword}
          placeholder="Your password"
          secureTextEntry
          blurOnSubmit={true}
          returnKeyType="go"
          onSubmitEditing={handleLogin}
        />

        <Button title="Sign In" onPress={handleLogin} loading={loading} />

        <View style={{ marginTop: 16, alignItems: "center" }}>
          <Link href="/(auth)/forgot-password/" asChild>
            <TouchableOpacity>
              <Text style={{ color: "#6b7280", fontSize: 14 }}>Forgot password?</Text>
            </TouchableOpacity>
          </Link>
        </View>

        <View style={{ marginTop: 16, alignItems: "center" }}>
          <Link href="/(auth)/register/" asChild>
            <TouchableOpacity>
              <Text style={{ color: "#2563eb", fontSize: 14 }}>
                Don't have an account? <Text style={{ fontWeight: "600" }}>Sign up</Text>
              </Text>
            </TouchableOpacity>
          </Link>
        </View>
      </ScrollView>
    </KeyboardAvoidingView>
  );
}
